// import Vue from 'vue'

const baseAPI = process.env.VUE_APP_SHINTARO_API_URL
const kaishuAPI = process.env.VUE_APP_KAISHU_API_URL

export default {
  /*********************
   * Vat rate
  **********************/
  vat_rate: baseAPI + '/vat/rate',
  vat_list: baseAPI + '/vat/list',

  /*********************
   * Estimates
  **********************/
  estimates_sequence: baseAPI + '/estimates/sequence',
  estimates_list: baseAPI + '/estimates/list',
  estimates_csv: baseAPI + '/estimates/csv',
  client_list: baseAPI + '/clients/list',
  update_client: baseAPI + '/clients/update',
  estimate_details: baseAPI + '/estimates/details',
  delete_estimate: baseAPI + '/estimates/delete',
  update_estimate: baseAPI + '/estimates/update',
  estimate_failure_to_receive: baseAPI + '/estimates/failure_to_receive',
  getPDF: baseAPI + '/estimates/pdf',
  add_estimate: baseAPI + '/estimates/add',
  products_keyword_search: baseAPI + '/search/products',
  destinations_list: baseAPI + '/delivery/list',

  /*********************
   * Sales
   *********************/
  sales_list: baseAPI + '/sales/list',
  sales_add: baseAPI + '/sales/add',
  sales_details: baseAPI + '/sales/details',
  sales_update: baseAPI + '/sales/update',
  sales_end_of_moth: baseAPI + '/sales/end_of_month',
  sales_year_closing_process: baseAPI + '/sales/year_closing_process',
  sales_closed_list: baseAPI + '/sales/closed_list',
  sales_open: baseAPI + '/sales/open',
  sales_close: baseAPI + '/sales/close',
  sales_opened_list: baseAPI + '/sales/opened_list',
  sales_delete: baseAPI + '/sales/delete',
  sales_unclosed_months: baseAPI + '/sales/unclosed_months',
  sales_closed_months: baseAPI + '/sales/closed_months',
  sales_unclosed_years: baseAPI + '/sales/unclosed_years',
  sales_closed_years: baseAPI + '/sales/closed_years',
  sales_delivery_slip: baseAPI + '/sales/delivery_slip',
  sales_csv: baseAPI + '/sales/csv',

  /*********************
   * Orders
   *********************/
  orders_sequence: baseAPI + '/orders/sequence',
  order_add_from_estimate: baseAPI + '/orders/add_from_estimate',
  orders_simple_list: baseAPI + '/orders/simple_list',
  details_by_order_number: baseAPI + '/orders/details_by_order_number',
  order_destination_list: baseAPI + '/orders/destination_list',
  order_get_products: baseAPI + '/orders/get_products',
  order_warehouse_product_list: baseAPI + '/orders/warehouse_product_list',
  order_shipped: baseAPI + '/orders/shipped',
  reserve_shipped: baseAPI + '/orders/shipped_reserves',
  order_move_reserve: baseAPI + '/orders/order_move_reserve',
  orders_list: baseAPI + '/orders/list',
  reserve_list: baseAPI + '/orders/reserve_list',
  orders_detail: baseAPI + '/orders/detail',
  reserves_detail: baseAPI + '/orders/reserve_detail',
  orders_update: baseAPI + '/orders/update',
  reserves_update: baseAPI + '/orders/reserve_update',
  orders_delete: baseAPI + '/orders/delete',
  reserves_delete: baseAPI + '/orders/reserve_delete',
  add_to_shipped: baseAPI + '/orders/shipped',
  handling_reserve_orders: baseAPI + '/orders/handling_reserves',
  move_to_shipped: baseAPI + '/orders/move_warehouse_order',
  orders_get_estimate: baseAPI + '/estimates/get_not_ordered_list',
  add_from_estimate: baseAPI + '/orders/add_from_estimate',
  orders_add: baseAPI + '/orders/add',
  orders_po_file: baseAPI + '/orders/po_show',
  orders_warehouse_products: baseAPI + '/orders/warehouse_product_list',
  reserve_warehouse_products: baseAPI + '/orders/reserve_warehouse_product_list',
  orders_consignment_warehouse_products: baseAPI + '/orders/consignment_warehouse_product_list',
  search_products: baseAPI + '/search/po_products',
  orders_delivery_slip: baseAPI + '/orders/delivery_slip',
  orders_consignment_slip: baseAPI + '/orders/consignment_slip',
  orders_confirm_consignment_sales: baseAPI + '/orders/confirm_consignment_sales',
  orders_update_consignment_stocks: baseAPI + '/orders/update_consignment_stocks',
  orders_neba: baseAPI + '/orders/neba',
  orders_quantity_remaining: baseAPI + '/orders/quantity_remaining',
  orders_csv: baseAPI + '/orders/csv',
  reserves_csv: baseAPI + '/orders/reserve_csv',

  /*********************
   * Billing
   *********************/
  billing_sequence: baseAPI + '/billing/sequence',
  billing_add: baseAPI + '/billing/add',
  bill_to_list: baseAPI + '/bill_to/list',
  invoices_list: baseAPI + '/billing/list',
  billing_status: baseAPI + '/billing/status',
  billing_details: baseAPI + '/billing/details',
  billing_update: baseAPI + '/billing/update',
  billing_delete: baseAPI + '/billing/delete',
  billing_add_payment: baseAPI + '/payment/add_from_billing',
  bulk_add_from_billing: baseAPI + '/payment/bulk_add_from_billing',
  billing_simple_list: baseAPI + '/billing/simple_list',
  billing_billed_list: baseAPI + '/billing/billed_list',
  billed_payment_list: baseAPI + '/billing/billed_payment_list',
  show_billing_pdf: baseAPI + '/billing/show_billing_pdf',
  show_realtime_billing: baseAPI + '/billing/show_realtime_billing',
  billing_nonbilled_list: baseAPI + '/billing/nonbilled_list',
  billing_send_bills: baseAPI + '/billing/send_bills',
  billing_change_memo: baseAPI + '/billing/change_memo',
  invoices_csv: baseAPI + '/billing/csv',

  /*********************
   * Stock
   *********************/
  stock_list: baseAPI + '/inventory/list',
  stock_list_v2: baseAPI + '/inventory/list_v2',
  inventory_closing: baseAPI + '/inventory/closing_procedure',
  inventory_list: baseAPI + '/inventory/inventory_check',
  inventory_status_list: baseAPI + '/inventory/status',
  inventory_personal_list: baseAPI + '/personnel/list',
  inventory_add: baseAPI + '/inventory/inventory_add',
  inventory_update: baseAPI + '/inventory/inventory_update',
  inventory_move: baseAPI + '/inventory/move_warehouses',
  inventory_pdf: baseAPI + '/inventory/inventory_pdf',
  inventory_unclosed_dates: baseAPI + '/inventory/unclosed_dates',
  inventory_change_jan: baseAPI + '/inventory/change_jan',
  inventory_remove: baseAPI + '/inventory/inventory_remove',
  inventory_inout: baseAPI + '/inventory/inout',
  inventory_quantity: baseAPI + '/inventory/quantity',
  inventory_quantity_disassembly: baseAPI + '/inventory/quantity_disassembly',
  inventory_origin_price_product: baseAPI + '/inventory/origin_price',
  inventory_note: baseAPI + '/inventory/inventory_note',
  inventory_update_list: baseAPI + '/inventory/inventory_update_list',
  inventory_update_single: baseAPI + '/inventory/inventory_update_out_single',
  inventory_last_history: baseAPI + '/inventory/inventory_last_history',
  inventory_save_session: baseAPI + '/inventory/inventory_cache_filter',
  inventory_get_session: baseAPI + '/inventory/get_cache_filter',
  inventory_quantity_single: baseAPI + '/inventory/quantity_single',
  inventory_inout_csv: baseAPI + '/inventory/inout_csv',
  /*********************
   * Payments
   *********************/

  payments_list: baseAPI + '/payment/list',
  payment_detail: baseAPI + '/payment/detail',
  payment_update: baseAPI + '/payment/update',
  payment_delete: baseAPI + '/payment/delete',
  payments_csv: baseAPI + '/payment/csv',

  /*********************
   * Return
   *********************/
  return_sequence: baseAPI + '/return/sequence',
  return_list: baseAPI + '/return/list',
  return_csv: baseAPI + '/return/csv',
  return_add: baseAPI + '/return/add',
  return_details: baseAPI + '/return/detail',
  return_update: baseAPI + '/return/update',
  return_delete: baseAPI + '/return/delete',
  return_reason_list: baseAPI + '/return/reason_list',
  return_process_status_list: baseAPI + '/return/process_status_list',
  return_states_list: baseAPI + '/return/states_list',
  return_seprate_products: baseAPI + '/return/seprate_products',
  return_bound_product: baseAPI + '/return/bound_product',
  return_move_to_stock: baseAPI + '/return/move_to_stock',
  return_add_reason: baseAPI + '/return/add_reason',
  return_discard: baseAPI + '/return/discard',
  return_delivery_slip: baseAPI + '/return/delivery_slip',
  return_detail_pdf: baseAPI + '/return/return_detail_pdf',
  return_change_status: baseAPI + '/return/change_status',
  return_change_state: baseAPI + '/return/change_state',
  return_change_reason: baseAPI + '/return/change_reason',
  return_change_test_result: baseAPI + '/return/change_test_result',
  return_change_taxclass: baseAPI + '/return/change_taxclass',
  return_change_selling_price: baseAPI + '/return/change_selling_price',
  return_change_quantity: baseAPI + '/return/change_quantity',
  return_change_remarks: baseAPI + '/return/change_remarks',
  return_update_is_processed: baseAPI + '/return/update_is_processed',
  return_product_list: baseAPI + '/return/product_list',
  return_change_status_multi: baseAPI + '/return/change_status_multi',
  return_upload_evident: baseAPI + '/return/return_upload_evident',
  view_file: new URL(baseAPI),
  return_delete_evident: baseAPI + '/return/return_delete_evident',
  return_ask_admin_email: baseAPI + '/return/return_ask_admin_email',
  return_admin_approve_email: baseAPI + '/return/return_admin_approve_email',
  return_last_confirm_change_status: baseAPI + '/return/return_last_confirm_change_status',

  /*********************
   * ReturnPartners
   *********************/
  return_partner_sequence: baseAPI + '/return_partners/sequence',
  return_partner_personal_list: baseAPI + '/personnel/list',
  return_partner_overseas_list: baseAPI + '/partners/overseas_list',
  return_partner_product_list: baseAPI + '/search/product_return_partner_list',
  return_partner_add: baseAPI + '/return_partners/add',
  return_partner_update: baseAPI + '/return_partners/update',
  return_partner_list: baseAPI + '/return_partners/list',
  return_partner_details: baseAPI + '/return_partners/detail',
  return_partner_delete: baseAPI + '/return_partners/delete',
  return_partner_change_reason: baseAPI + '/return_partners/change_reason',
  return_partner_change_state: baseAPI + '/return_partners/change_state',
  return_partner_change_test_result: baseAPI + '/return_partners/change_test_result',
  return_partner_change_remarks: baseAPI + '/return_partners/change_remarks',
  return_partner_last_confirm_change_status: baseAPI + '/return_partners/return_last_confirm_change_status',
  return_partner_change_selling_price: baseAPI + '/return_partners/change_selling_price',
  return_partner_check_quantity_product: baseAPI + '/search/check_quantity_product_return_partner',
  return_partner_csv: baseAPI + '/return_partners/csv',

  /*********************
   * Replacement
   *********************/
  replacement_sequence: baseAPI + '/replacement/sequence',
  replacement_list: baseAPI + '/replacement/list',
  replacement_process_status_list: baseAPI + '/replacement/process_status_list',
  replacement_get_products: baseAPI + '/replacement/get_products',
  replacement_bound_product: baseAPI + '/replacement/bound_product',
  replacement_details: baseAPI + '/replacement/detail',
  replacement_update: baseAPI + '/replacement/update',
  replacement_add: baseAPI + '/replacement/add',
  replacement_warehouse_products: baseAPI + '/replacement/warehouse_product_list',
  replacement_add_to_shipped: baseAPI + '/replacement/shipped',
  replacement_delivery_slip: baseAPI + '/replacement/delivery_slip',
  replacement_change_status: baseAPI + '/replacement/change_status',
  replacement_change_state: baseAPI + '/replacement/change_state',
  replacement_change_reason: baseAPI + '/replacement/change_reason',
  replacement_change_test_result: baseAPI + '/replacement/change_test_result',
  replacement_change_selling_price: baseAPI + '/replacement/change_selling_price',
  replacement_change_remarks: baseAPI + '/replacement/change_remarks',
  replacement_update_is_processed: baseAPI + '/replacement/update_is_processed',
  replacement_change_arrived_warehouse: baseAPI + '/replacement/change_arrived_warehouse',
  replacement_change_shipped_warehouse: baseAPI + '/replacement/change_shipped_warehouse',
  replacement_delete: baseAPI + '/replacement/delete',
  replacement_shipped_warehouse_products: baseAPI + '/replacement/shipped_warehouse_product_list',
  replacement_csv: baseAPI + '/replacement/csv',

  /*********************
   * ConsignmentReturn
   *********************/
  consignment_return_add: baseAPI + '/consignment_return/add',
  consignment_return_list: baseAPI + '/consignment_return/list',
  consignment_return_delivery_slip: baseAPI + '/consignment_return/delivery_slip',
  consignment_return_details: baseAPI + '/consignment_return/detail',
  consignment_return_move_to_stock: baseAPI + '/consignment_return/move_to_stock',
  consignment_return_update: baseAPI + '/consignment_return/update',
  consignment_return_delete: baseAPI + '/consignment_return/delete',
  consignment_return_bound_product: baseAPI + '/consignment_return/bound_product',
  consignment_return_change_status: baseAPI + '/consignment_return/change_status',
  consignment_return_change_state: baseAPI + '/consignment_return/change_state',
  consignment_return_change_reason: baseAPI + '/consignment_return/change_reason',
  consignment_return_change_test_result: baseAPI + '/consignment_return/change_test_result',
  consignment_return_change_taxclass: baseAPI + '/consignment_return/change_taxclass',
  consignment_return_change_selling_price: baseAPI + '/consignment_return/change_selling_price',
  consignment_return_change_quantity: baseAPI + '/consignment_return/change_quantity',
  consignment_return_change_remarks: baseAPI + '/consignment_return/change_remarks',
  consignment_return_update_is_processed: baseAPI + '/consignment_return/update_is_processed',
  consignment_return_change_arrived_warehouse: baseAPI + '/consignment_return/change_arrived_warehouse',
  consignment_return_csv: baseAPI + '/consignment_return/csv',

  /*********************
   * Discard
   *********************/
  discard_personnel: baseAPI + '/personnel/list',
  discard_partners: baseAPI + '/partners/overseas_list',
  discard_detail: baseAPI + '/discards/detail',
  discard_product_list: baseAPI + '/search/product_list',
  discard_list: baseAPI + '/discards/list',
  discard_add: baseAPI + '/discards/add',
  discard_update: baseAPI + '/discards/update',
  discard_delete: baseAPI + '/discards/delete',
  discard_update_is_processed: baseAPI + '/discards/update_is_processed',
  discard_sequence: baseAPI + '/discards/sequence',

  /*********************
   * Warehouse
   *********************/
  warehouse_list: baseAPI + '/warehouses/list',
  vander_list: baseAPI + '/venders/list',

  /*********************
   * Budget
   *********************/
  budgets_list: baseAPI + '/budget/list',
  budgets_by_personnel: baseAPI + '/budget/details_by_personnel',
  budget_delete: baseAPI + '/budget/delete',
  budget_update_personnel: baseAPI + '/budget/update_by_personnel',
  budget_contacts: baseAPI + '/accounts/sales_accounts_list',
  budget_add: baseAPI + '/budget/add',
  budget_years_list: baseAPI + '/budget/years_list',

  /*********************
   * Cost
   *********************/
  cost_list: baseAPI + '/cost/list',
  cost_add_year: baseAPI + '/cost/add_year',
  cost_delete_year: baseAPI + '/cost/delete_by_year',
  cost_update: baseAPI + '/cost/update',
  load_years: baseAPI + '/cost/year_list',

  /*********************
   * Receivable
   *********************/
  receivable_list: baseAPI + '/accounts_receivable/list',
  receivable_csv: baseAPI + '/accounts_receivable/csv',

  /*********************
   * Payable
   *********************/
  payable_list: baseAPI + '/accounts_payable/list',
  payable_csv: baseAPI + '/accounts_payable/csv',

  /*********************
   * Partners
   *********************/
  partner_list: kaishuAPI + '/partners',
  partner_list_params: { 'suppliers': '1', 'is_jp': '1' },

  /*********************
   * Withdrawal
   *********************/
  // partner_list: baseAPI + '/partners/list',
  withdrawal_list: baseAPI + '/withdrawal/list',
  withdrawal_detail: baseAPI + '/withdrawal/detail',
  withdrawal_update: baseAPI + '/withdrawal/update',
  withdrawal_delete: baseAPI + '/withdrawal/delete',
  defrayment_simple_list: baseAPI + '/defrayment/simple_list',
  defraymented_withdrawal_list: baseAPI + '/defrayment/defraymented_withdrawal_list',
  withdrawal_add_defrayment: baseAPI + '/withdrawal/add_from_defrayment',

  /*********************
   * Purchase/Stockings
   *********************/
  purchase_stocking_opened_list: baseAPI + '/stocking/opened_list',
  purchase_stocking_close: baseAPI + '/stocking/close',
  purchase_stocking_closed_list: baseAPI + '/stocking/closed_list',
  purchase_stocking_disable_close: baseAPI + '/stocking/disable_close',
  purchase_stocking_year_closing_process: baseAPI + '/stocking/year_closing_process',
  purchase_stocking_po_simple_list: baseAPI + '/po/simple_list',
  purchase_stocking_details: baseAPI + '/stocking/details',
  purchase_stocking_list: baseAPI + '/stocking/list',
  purchase_stocking_delete: baseAPI + '/stocking/delete',
  purchase_stocking_update: baseAPI + '/stocking/update',
  purchase_stocking_claim: baseAPI + '/stocking/claim',
  purchase_stocking_nonpaid_list: baseAPI + '/stocking/nonpaid_list',
  purchase_stocking_send_payment: baseAPI + '/stocking/send_payment_statements',
  purchase_stocking_unclosed_month: baseAPI + '/stocking/unclosed_months',
  purchase_stocking_closed_months: baseAPI + '/stocking/closed_months',
  purchase_stocking_unclosed_year: baseAPI + '/stocking/unclosed_years',
  purchase_stocking_closed_year: baseAPI + '/stocking/closed_years',
  purchase_stocking_pdf: baseAPI + '/stocking/pdf',
  purchase_stocking_invoice_show: baseAPI + '/stocking/invoice_show',
  purchase_stocking_csv: baseAPI + '/stocking/csv',

  /*********************
   * Purchase/Orders
   *********************/
  purchase_sequence: baseAPI + '/purchase/sequence',
  purchase_partners_list: baseAPI + '/partners/list',
  purchase_partners_overseas_list: baseAPI + '/partners/overseas_list',
  purchase_list: baseAPI + '/purchase/list',
  purchase_overseas_list: baseAPI + '/purchase/overseas_list',
  purchase_overseas_detail: baseAPI + '/purchase/details_overseas',
  purchase_detail: baseAPI + '/purchase/details',
  purchase_delete: baseAPI + '/purchase/delete',
  purchase_add: baseAPI + '/purchase/add',
  purchase_update: baseAPI + '/purchase/update',
  purchase_invoice_show: baseAPI + '/purchase/invoice_show',
  // purchase_pdf: baseAPI + '/po/pdf', // OLD
  purchase_pdf: baseAPI + '/purchase/pdf_new', // NEW
  purchase_stocking_arrival: baseAPI + '/stocking/arrival',
  purchase_payment: baseAPI + '/purchase/payment',
  purchase_csv: baseAPI + '/purchase/csv',
  purchase_overseas_csv: baseAPI + '/purchase/overseas_csv',

  /**********************
   * PurchasePayments
   **********************/
  purchase_payments_list: baseAPI + '/purchase_payment/list',
  purchase_payments_detail: baseAPI + '/purchase_payment/detail',
  purchase_payments_update: baseAPI + '/purchase_payment/update',
  purchase_payments_delete: baseAPI + '/purchase_payment/delete',
  purchase_payments_csv: baseAPI + '/purchase_payment/csv',

  // purchase_payments_sequence: baseAPI + '/defrayment/sequence',
  // purchase_payments_status_list: baseAPI + '/defrayment/status',
  // purchase_payments_defrayment_list: baseAPI + '/defrayment/defrayment_list',
  // purchase_payments_bulk_add: baseAPI + '/withdrawal/bulk_add_from_defrayments',

  /**********************
   * Summary Sales
   **********************/
  summary_sales: baseAPI + '/stats/sales',

  /**********************
   * Accounts
   **********************/
  account_login: baseAPI + '/account/login',
  account_logout: baseAPI + '/account/logout',
  account_forgot_password: baseAPI + '/account/forgot_password',
  account_change_password: baseAPI + '/account/change_password',
  account_details: baseAPI + '/account/details',
  account_details_update: baseAPI + '/account/update',
  account_company: baseAPI + '/account/company',
  account_company_update: baseAPI + '/account/company_update',
  account_user_list: baseAPI + '/account/user_list',
  account_add: baseAPI + '/account/add',
  account_update: baseAPI + '/account/update',
  account_approve_user: baseAPI + '/account/approve_user',
  account_delete: baseAPI + '/account/delete',
  account_privilege_list: baseAPI + '/account/privilege_list',
  account_division_list: baseAPI + '/account/division_list',
  account_position_list: baseAPI + '/account/position_list',

  /*********************
   * Products
   *********************/
  products_sets: baseAPI + '/products_sets',
  detach_product_sets: baseAPI + '/products_sets/detach',
  products_list: baseAPI + '/products',
  check_inventory: baseAPI + '/inventory/check_inventory',
  update_check_inventory: baseAPI + '/inventory/inventory_update_list',
  import_csv_inventory: baseAPI + '/inventory/inventory_import_csv',
  diff_inventory: baseAPI + '/inventory/inventory_diff',

  /*********************
   * WarehouseUsers
   *********************/
  warehouse_users: baseAPI + '/warehouse_user/list',
  warehouse_user_add: baseAPI + '/warehouse_user/add',
  warehouse_user_detail: baseAPI + '/warehouse_user/detail',
  warehouse_user_update: baseAPI + '/warehouse_user/update',
  warehouse_user_remove: baseAPI + '/warehouse_user/remove',
  warehouse_user_login: baseAPI + '/warehouse_user/login',
  warehouse_user_forgot_password: baseAPI + '/warehouse_user/forgot_password',

  /*********************
   * ShippingInstructions
   *********************/
  shipping_instructions: baseAPI + '/shipping_instructions',
  download_list: baseAPI + '/edi_master_file/list',
  download_file: baseAPI + '/edi_master_file/download',
  edi_master_file_delete: baseAPI + '/edi_master_file/delete',
  employee_by_company: baseAPI + '/personnel/get_employee_from_company',
  quantity_full_warehouse: baseAPI + '/inventory/quantity_full_warehouse',
  template_shipping_instruction: baseAPI + '/template_shipping_instruction',
  create_template_shipping_instruction: baseAPI + '/template_shipping_instruction/create',
  update_template_shipping_instruction: baseAPI + '/template_shipping_instruction/update/',
  delete_template_shipping_instruction: baseAPI + '/template_shipping_instruction/delete/',
  template_shipping_instruction_delivery_slip: baseAPI + '/template_shipping_instruction/delivery_slip',

  /*********************
   * Dashboard
   *********************/
  customers: baseAPI + '/clients',
  personel: baseAPI + '/personnel',
  categories: baseAPI + '/product_category',
  partners: baseAPI + '/partners',
  progress_bar_chart: baseAPI + '/dashboard/progress_bar_chart',
  progress_pie_chart: baseAPI + '/dashboard/pie_chart',
  progress_bar_chart_actual_revenue: baseAPI + '/dashboard/revenue_budget_chart',
  progress_bar_chart_actual_profit: baseAPI + '/dashboard/profit_budget_chart',
  line_chart: baseAPI + '/dashboard/trend_chart',
  detail: baseAPI + '/dashboard/detail',
  dashboard_detail_csv_download: baseAPI + '/dashboard/csv_detail',

  /*********************
   * VersionDeploy
   *********************/
  version_deploy: baseAPI + '/version_deploy/list'
}
